// extracted by mini-css-extract-plugin
module.exports = {"guide":"PurchaseOrder_guide__1CcA8","intro_1":"PurchaseOrder_intro_1__2FvJc","intro":"PurchaseOrder_intro__38Uq4"};